
import Vue, { PropType } from "vue";
import { DcmConfigService } from "@/@modules/fseg/services/DcmConfigService";
import { DcmDocumentListConfig, DcmDocumentListQuery } from "@/@modules/dcm/interfaces/DcmDocumentListConfiguration";
import DocumentList from "@/@modules/dcm/components/DocumentList.vue";

export default Vue.extend({
  components: {
    DocumentList,
  },
  props: {
    config: {
      type: Object as PropType<DcmDocumentListConfig<DcmDocumentListQuery>>,
      required: true,
    },
  },
  data() {
    return {
      getConfigForExpandedItem: DcmConfigService.getConfigForSignatureDetails,
    };
  },
});
